import React from 'react'
import { graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image"
import { css } from '@emotion/core'
import Container from 'components/Container'
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import Link from '../components/Link'
import { bpMaxSM, bpMaxMD } from '../lib/breakpoints'
import { useTheme } from 'components/Theming'

const Blog = ({
  data: { site, allMdx },
  pageContext: { pagination, categories },
}) => {
  const { page, nextPagePath, previousPagePath } = pagination

  const theme = useTheme()

  const posts = page
    .map(id => allMdx.edges.find(edge => edge.node.id === id))
    .filter(post => post !== undefined)

  return (
    <Layout site={site}>
      <SEO />
      <Container noVerticalPadding>
        {posts.map(({ node: post }) => (
          <div
            key={post.id}
            css={css`
              :not(:first-of-type) {
                margin-top: 60px;
                ${bpMaxMD} {
                  margin-top: 40px;
                }
                ${bpMaxSM} {
                  margin-top: 20px;
                }
              }
              :first-of-type {
                margin-top: 20px;
                ${bpMaxSM} {
                  margin-top: 20px;
                }
              }
              .gatsby-image-wrapper {
              }
              ${bpMaxSM} {
                padding: 20px;
              }
              display: flex;
              flex-direction: column;
            `}
          >
            {post.frontmatter.banner && (
              <div
                css={css`
                  padding: 60px 60px 40px 60px;
                  ${bpMaxSM} {
                    padding: 20px;
                  }
                `}
              >
                <Link
                  aria-label={`View ${post.frontmatter.title} note`}
                  to={`/${post.fields.slug}`}
                >
                  <GatsbyImage 
                    image={post.frontmatter.banner.childImageSharp.gatsbyImageData}
                    alt={post.frontmatter.banner.name || ""}
                  />
                </Link>
              </div>
            )}
            <h2
              css={css`
                margin-top: 30px;
                margin-bottom: 10px;
              `}
            >
              <Link
                aria-label={`View ${post.frontmatter.title} note`}
                to={`/${post.fields.slug}`}
              >
                {post.frontmatter.title}
              </Link>
            </h2>
            {/* <small>{post.frontmatter.date}</small> */}
            <p
              css={css`
                margin-top: 10px;
              `}
            >
              {post.excerpt}
            </p>{' '}
            <Link
              to={`/${post.fields.slug}`}
              aria-label={`view "${post.frontmatter.title}" note`}
              css={css(`
                  display: inline-block;
                  font-size: 0.75rem !important;
                  letter-spacing: 0.1em;
                  margin-top: 0.5rem;
                  text-decoration: none;
                  text-transform: uppercase;
                  color: ${theme.colors.green} !important;
                 `)}
            >
              Read this post &rsaquo;
            </Link>
          </div>
        ))}
        <div css={css({ marginTop: '30px' })}>
          {previousPagePath && (
            <Link to={previousPagePath} aria-label="View previous page"
            css={css(`
              font-size: 0.75rem !important;
              letter-spacing: 0.1em;
              margin-top: 0.5rem;
              text-decoration: none;
              text-transform: uppercase;
              color: ${({theme}) => theme.colors.green} !important;
              `)}
              >
              ← Older posts
            </Link>
          )}

          {nextPagePath && (
            <Link to={nextPagePath} aria-label="View next page"
            css={css(`
                font-size: 0.75rem !important;
                letter-spacing: 0.1em;
                margin-top: 0.5rem;
                text-decoration: none;
                text-transform: uppercase;
                float: right;
                color: ${theme.colors.green} !important;
              `)}
            >
              Newer posts →
            </Link>
          )}
        </div>
        <hr
          css={css`
            margin: 50px 0;
          `}
        />
      </Container>
    </Layout>
  )
}

export default Blog

export const pageQuery = graphql`
  query {
    site {
      ...site
    }
    allMdx(
      sort: { fields: [fields___mostRecentChange], order: DESC }
      filter: { fields: { isPost: { eq: true } } }
    ) {
      edges {
        node {
          excerpt(pruneLength: 300)
          id
          fields {
            title
            slug
            date
            mostRecentChange
          }
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            banner {
              childImageSharp {
                gatsbyImageData(layout: FULL_WIDTH)
              }
            }
            slug
            keywords
          }
        }
      }
    }
  }
`
